module.exports = __webpack_public_path__ + "static/img/lead-count-cold-green.6ab726d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/lead-count-cold-green.svg
// module id = 456
// module chunks = 0